"use client";

import { useMemo } from "react";
import { v4 as uuidv4 } from "uuid";

const TAB_ID_STORAGE_KEY = "focal_tab_id";

/**
 * Generates or retrieves a unique identifier for the current browser tab/window.
 * Uses sessionStorage which is tab-specific, so each tab gets its own ID.
 * Uses UUID v4 for generating unique identifiers.
 */
export const getOrCreateTabId = (): string => {
  if (typeof window === "undefined") {
    // Server-side rendering - return a placeholder
    return "server-tab-id";
  }

  let tabId = sessionStorage.getItem(TAB_ID_STORAGE_KEY);

  if (!tabId) {
    // Generate a unique ID for this tab using UUID v4
    tabId = uuidv4();
    sessionStorage.setItem(TAB_ID_STORAGE_KEY, tabId);
  }

  return tabId;
};

/**
 * Hook to get the current tab ID
 */
export const useTabId = (): string => {
  return useMemo(() => getOrCreateTabId(), []);
};
